<template>
  <div>
    <LoadingOverlay :active="loading" />
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay/index.vue";
export default {
  components: {
    LoadingOverlay,
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.loading = false;
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener(
      "hashchange",
      () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    },
  },
  watch: {
    "$store.state.common.loading": {
      handler(n) {
        this.loading = n;
      },
      immediate: true,
    },
  },
};
</script>
